<template>
    <Section eyebrow="Why us" title="Best Arabic & Quran Learning Experience">
        <div class="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">
            <Card v-for="feature in features" :key="feature.name" class="text-center">
                <div class="mx-auto flex size-14 items-center justify-center rounded-2xl bg-primary-50">
                    <img v-if="feature.icon" :src="feature.icon" alt="" class="size-7" />
                </div>
                <h3 class="mt-6 text-base font-semibold text-gray-900">{{ feature.name }}</h3>
                <p class="mt-2 text-sm/6 text-gray-600">{{ feature.description }}</p>
            </Card>
        </div>
    </Section>
</template>

<script setup>
import Section from '@/components/ui/Section.vue';
import Card from '@/components/ui/Card.vue';

const features = [
    {
        name: 'Native Arabic Tutors',
        description: 'Our tutors are native Arabic speakers, ensuring an authentic learning experience.',
        icon: 'images/icons/features/arabic.png',
    },
    {
        name: 'Flexible Scheduling',
        description: 'Choose your own schedule and learn at your own pace.',
        icon: 'images/icons/features/calendar.png',
    },
    {
        name: 'Interactive Learning',
        description: 'Engaging lessons with interactive tools and resources.',
        icon: 'images/icons/features/chat.png',
    },
    {
        name: 'Certified Tutors',
        description: 'Al-Azhar certified professional teachers are available.',
        icon: 'images/icons/features/certified.png',
    },
    {
        name: 'Comprehensive Curriculum',
        description: 'A well-structured curriculum covering all aspects of Arabic and Quranic studies.',
        icon: 'images/icons/features/zip.png',
    },
    {
        name: '24/7 Support',
        description: 'Our support team is available around the clock to assist you.',
        icon: 'images/icons/features/support.png',
    },
]
</script>
